import React, { useMemo } from "react";
import {
	BATCH_DEDUCTION, BATCH_SMS_SEND, getBatchActionConfigs,
} from "@icoach/batchPayment/staticData";
import BatchActionTable from "@icoach/batchPayment/component/BatchActionTable";
import { getDebitACHRowsLabel } from "@icoach/batchPayment/component/DebitACHRowsLabelTemplate";

const DebitListForACH = ({ headerRow, list, sourceData, searchParams, dialogRef, refresh }) => {

	const batchActions = useMemo(
		() => {
			const batchActions = getBatchActionConfigs({ searchParams, sourceData, refresh })
			return (
				{
					[BATCH_DEDUCTION]: {
						...batchActions[BATCH_DEDUCTION]
					},
					[BATCH_SMS_SEND]: {
						...batchActions[BATCH_SMS_SEND]
					}
				}
			)
		},
		// eslint-disable-next-line
		[]
	);

	const defaultHeaderRow = useMemo(
		() => {
			return getDebitACHRowsLabel();
		},
		// eslint-disable-next-line
		[]
	);


	return <BatchActionTable batchActions={batchActions} list={list} headerRow={headerRow ? headerRow : defaultHeaderRow} dialogRef={dialogRef}
							 refresh={refresh} />;
};

export default DebitListForACH;
